import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Sparkles, TrendingUp, ChevronRight, Flame, Wand2 } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const PRIO = { alta: "#ef4444", media: "#f59e0b", baja: "#0ea5e9" };

export function TrendingChallenges() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;
    fetch(`${BACKEND_URL}/api/nova/trending?limit=5`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.json())
      .then((d) => { setItems(d.trending || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  if (loading || !items.length) return null;

  return (
    <motion.section
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2 }}
      data-testid="trending-widget"
      style={{
        marginBottom: 40,
        borderRadius: 20,
        padding: 24,
        background: "linear-gradient(135deg, rgba(168,85,247,0.08) 0%, rgba(59,173,45,0.06) 100%)",
        border: "1px solid rgba(168,85,247,0.18)",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16, gap: 12, flexWrap: "wrap" }}>
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 8, color: "#c4b5fd", fontSize: 11, letterSpacing: "0.25em", textTransform: "uppercase", fontWeight: 700 }}>
            <Flame size={14}/> NOVA · Trending Retos
          </div>
          <h2 style={{ fontSize: 20, fontWeight: 800, color: "#f1f5f9", marginTop: 4 }}>Lo más votado en este momento</h2>
          <p style={{ fontSize: 12, color: "rgba(241,245,249,0.55)", marginTop: 2 }}>Top 5 retos con más votos del equipo aún sin pasar a portfolio</p>
        </div>
        <button
          onClick={() => navigate("/nova")}
          data-testid="trending-open-nova"
          style={{ background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)", color: "#fff", padding: "8px 14px", borderRadius: 999, fontSize: 12, fontWeight: 600, display: "flex", alignItems: "center", gap: 6, cursor: "pointer" }}
        >
          <Sparkles size={14}/> Abrir NOVA <ChevronRight size={14}/>
        </button>
      </div>

      <div style={{ display: "grid", gap: 10 }}>
        {items.map((c, i) => (
          <motion.div
            key={c.id}
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.05 * i }}
            onClick={() => navigate(`/nova/${c.campaign_id}`)}
            data-testid={`trending-${c.id}`}
            style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: 12, padding: "12px 14px", borderRadius: 14, background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)" }}
            whileHover={{ background: "rgba(255,255,255,0.08)" }}
          >
            <div style={{ flexShrink: 0, width: 40, height: 40, borderRadius: 12, background: "linear-gradient(135deg,#7c3aed,#a78bfa)", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: 14 }}>
              #{i + 1}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 3 }}>
                <span style={{ width: 6, height: 6, borderRadius: 999, background: PRIO[c.priority] || "#94a3b8" }}/>
                <span style={{ fontSize: 10, textTransform: "uppercase", letterSpacing: "0.08em", color: "rgba(241,245,249,0.5)" }}>{c.area || c.campaign_name}</span>
              </div>
              <div style={{ color: "#f1f5f9", fontSize: 13, fontWeight: 600, lineHeight: 1.35, overflow: "hidden", textOverflow: "ellipsis", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical" }}>
                {c.title}
              </div>
              {c.champion && <div style={{ fontSize: 11, color: "rgba(241,245,249,0.45)", marginTop: 3 }}>👤 {c.champion}</div>}
            </div>
            <div style={{ flexShrink: 0, display: "flex", alignItems: "center", gap: 12 }}>
              <div style={{ textAlign: "right" }}>
                <div style={{ fontSize: 18, fontWeight: 900, color: "#a78bfa" }}>{c.votes}</div>
                <div style={{ fontSize: 9, color: "rgba(241,245,249,0.4)", textTransform: "uppercase", letterSpacing: "0.08em" }}>votos</div>
              </div>
              {c.match_score != null ? (
                <div style={{ background: "rgba(59,173,45,0.15)", border: "1px solid rgba(59,173,45,0.4)", color: "#4ade80", padding: "6px 10px", borderRadius: 999, fontSize: 11, fontWeight: 700, display: "flex", alignItems: "center", gap: 4 }} title={c.match_name}>
                  <Wand2 size={11}/> {c.match_score}%
                </div>
              ) : (
                <div style={{ background: "rgba(148,163,184,0.1)", color: "rgba(241,245,249,0.4)", padding: "6px 10px", borderRadius: 999, fontSize: 11, fontWeight: 600 }}>
                  Sin match
                </div>
              )}
            </div>
          </motion.div>
        ))}
      </div>
    </motion.section>
  );
}
